module.exports = __webpack_public_path__ + "img/backg.a47d293e.png";